import FormInput from 'components/FormInput';
import React, { useState } from 'react';
import toast from 'react-hot-toast';
import Modal from '../Modal/Modal';
import { AddModalProps } from './types';

import './AddModal.scss';
import { useTranslation } from 'react-i18next';

export const AddModal: React.FC<AddModalProps> = ({
  open,
  title,
  allowSpace = true,
  inputLabel,
  onSubmit,
  onClose,
}) => {
  const { t } = useTranslation();
  const [value, setValue] = useState('');
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) =>
    setValue(allowSpace ? e.target.value : e.target.value.trim());
  const handleSubmit = () => {
    if (value.trim().length) {
      onSubmit(value.trim());
    } else {
      toast.error(t('error_input_field_can_not_be_blank'));
    }
    setValue('');
  };
  const handleClose = () => {
    onClose();
    setValue('');
  };

  const handleKeyDown = (e: any) => {
    if (e.key === 'Enter') {
      handleSubmit();
    }
  };

  return (
    <Modal
      show={open}
      modalClassName="add-modal"
      submitBtnText={t('btn_add')}
      title={title || ''}
      footerContentAlignment="center"
      onClose={handleClose}
      onSubmit={handleSubmit}
      onBackDropClick={handleClose}
    >
      <FormInput
        value={value}
        name="other"
        label={inputLabel}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
      />
    </Modal>
  );
};
